namespace TabAurous.Production {
    export interface IssueMaterialRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        BagNo?: string;
        Line_No?: number;
        Pieces?: number;
        DepartmentId?: number;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: IssueMaterialDetailsRow[];
        ProductCode?: string;
        AutoPosting?: boolean;
        ImageName?: string;
        PostingDate?: string;
        IsPosted?: boolean;
    }

    export namespace IssueMaterialRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.IssueMaterial';
        export const deletePermission = 'Production:IssueMaterial:Delete';
        export const insertPermission = 'Production:IssueMaterial:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:IssueMaterial:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            BagNo = "BagNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            ProductCode = "ProductCode",
            AutoPosting = "AutoPosting",
            ImageName = "ImageName",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted"
        }
    }
}
